import React, { Component } from "react";
//import { css } from "@emotion/core";
import BarLoader from "react-bar-loader";
import {
  Alert,
  Col,
  Form,
  Button,
  FormGroup,
  FormControl,
  ControlLabel as FormLabel
} from "react-bootstrap";

import logo from "assets/img/reactlogo.svg";

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      login: "",
      password: "",
      loginError: false,
      loader: false
    };
  }

  validateForm() {
    return this.state.login.length > 0 && this.state.password.length > 0;
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  };

  handleSubmit = event => {
    event.preventDefault();
  };

  handleLogin = () => {
    this.setState({ loader: true });
    var url = "https://hgsystem.pl/mangusta/login2.php";

    fetch(url, {
      method: "POST",
      headers: {
        Accept: "aplication/json, text/plain, */*",
        "Content-type": "aplication/json"
      },
      body: JSON.stringify({
        login: this.state.login,
        haslo: this.state.password,
        firstTime: true
      })
    })
      .then(resp => resp.json())
      .catch(err => console.log("There was an error:" + err))
      .then(data => {
        if (data.user) this.props.onLogin(data);
        else this.setState({ loginError: true, loader: false });
      })
      .catch(err => console.log("There was an error:" + err));
  };

  render() {
    //console.log(this.state);
    // const override = css`
    //   display: block;
    //   margin: 0 auto;
    //   border-color: red;
    // `;

    return (
      <React.Fragment>
        <div className="logo-img simple-text logo-normal text-center">
          <img
            src={logo}
            alt="logo logo_image"
            style={{ height: 40, margin: 20 }}
          />
        </div>
        <div className="container" style={{ padding: 30 }}>
          <Col lg={3} sm={2} />
          <Col lg={6} sm={8}>
            <Form>
              {this.state.loginError === true ? (
                <Alert key={1} variant="danger">
                  Błędne dane logowania
                </Alert>
              ) : null}
              <FormGroup controlId="login" bsSize="large">
                <FormLabel>Login</FormLabel>
                <FormControl
                  bsClass="form-control"
                  autoFocus
                  type="login"
                  value={this.state.login}
                  onChange={this.handleChange}
                />
              </FormGroup>
              <FormGroup controlId="password" bsSize="large">
                <FormLabel>Hasło</FormLabel>
                <FormControl
                  value={this.state.password}
                  onChange={this.handleChange}
                  type="password"
                />
              </FormGroup>
              <div className="text-center">
                <Button
                  bsSize="large"
                  disabled={!this.validateForm()}
                  onClick={() => this.handleLogin()}
                >
                  Zaloguj
                </Button>
              </div>
            </Form>
            {this.state.loader ? (
              <div className="sweet-loading">
                {/* <ClipLoader
                sizeUnit={"px"}
                size={150}
                color={"#123abc"}
                loading={true}
              /> */}
                <BarLoader color="#1D8BF1" height="2" />
              </div>
            ) : null}
          </Col>
          <Col lg={3} sm={2} />
        </div>
      </React.Fragment>
    );
  }
}
export default Login;



// WEBPACK FOOTER //
// ./src/components/Login/Login.jsx